var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComparisonPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comparison",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_280",
    "data-name": "Ellipse 280",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#1dbbbe"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comparison-svgrepo-com",
    d: "M4.208,1.6a3.208,3.208,0,0,1,1.82,5.851l-.216.136v6.846a4.813,4.813,0,0,0,2.932,4.431l.276.107V16.041l4.812,4.812L9.021,25.666V22.3a8.024,8.024,0,0,1-6.408-7.5L2.6,14.437V7.591A3.209,3.209,0,0,1,4.208,1.6ZM15.437,0V3.369a8.023,8.023,0,0,1,6.417,7.86v6.846a3.208,3.208,0,1,1-3.208,0V11.229A4.814,4.814,0,0,0,15.437,6.69V9.625L10.625,4.812Z",
    transform: "translate(5.771 5.667)",
    fill: "#f7fcff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonPackages);
export default __webpack_public_path__ + "static/media/comparisonPackages.ce1098d5e59b74b6a51fda6c362a778a.svg";
export { ForwardRef as ReactComponent };